import React from "react";
import ISOHeader14001 from "../../../components/ISO Certificates/ISO 14001-2015/ISOHeader14001";
import ISOContent14001 from "../../../components/ISO Certificates/ISO 14001-2015/ISOContent14001";
import ISOServiceIndia9001 from "../../../components/ISO Certificates/ISO Common/ISOServiceIndia9001";
import ISOCertificationCost9001 from "../../../components/ISO Certificates/ISO Common/ISOCertificationCost9001";
import ISOBenifit9001 from "../../../components/ISO Certificates/ISO Common/ISOBenifit9001";

const ISO450012015 = () => {
  return (
    <div>
      <ISOHeader14001 />
      <ISOContent14001 />
      <ISOServiceIndia9001 />
      <ISOCertificationCost9001 />
      <ISOBenifit9001 />
    </div>
  );
};

export default ISO450012015;
